var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawerLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 3,
    viewBox: "0 0 32 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.43203C0 1.54838 0.716344 0.832031 1.6 0.832031H30.4C31.2837 0.832031 32 1.54838 32 2.43203C32 2.65295 31.8209 2.83203 31.6 2.83203H0.4C0.179086 2.83203 0 2.65295 0 2.43203Z",
    fill: "#77787B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerLine);
export default __webpack_public_path__ + "static/media/drawer-line.aaf1d50129520e3c6ade86b6a8663eaf.svg";
export { ForwardRef as ReactComponent };